import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger';
import { JobSheetInterface } from '../interfaces/job-sheet.interface';
import { Exclude, Expose, Type } from 'class-transformer';
import { CommonEntityDto } from '../../common/dto/common-entity.dto';
import { IsOptional, ValidateNested } from 'class-validator';
import { GeographyPointDto } from '../../common/dto/geography-point.dto';
import { Point } from 'geojson';

@Exclude()
export class JobSheetDto extends CommonEntityDto implements JobSheetInterface {
  @ApiProperty({
    title: 'Job ID (synonym for React Admin only)',
  })
  @Expose()
  id!: string;

  @ApiProperty({
    title: 'Job ID',
  })
  @Expose()
  jobId!: string;

  @ApiProperty({
    title: 'Job Lot',
  })
  @Expose()
  jobLot!: string;

  @ApiProperty({
    title: 'Job Block',
  })
  @Expose()
  jobBlock!: string | null;

  //
  // Subdivision fields
  //

  @ApiProperty({
    title: 'Subdivision ID',
  })
  @Expose()
  subdivisionId!: string;

  @ApiProperty({
    title: 'Subdivision Name',
  })
  @Expose()
  subdivisionName!: string;

  //
  // Supervisior
  //
  @ApiProperty({
    title: 'Supervisor User ID',
  })
  @Expose()
  supervisorUserIds!: string;

  //
  // Builder fields
  //

  @ApiProperty({
    title: 'Builder Id',
  })
  @Expose()
  builderId!: string;

  @ApiProperty({
    title: 'Builder Name',
  })
  @Expose()
  builderName!: string;

  //
  // Supplier fields
  //

  @ApiProperty({
    title: 'Supplier Id',
    description: 'Supplier Id of last Board Purchase created for this Job',
  })
  @Expose()
  supplierId!: string;

  @ApiProperty({
    title: 'Supplier Name',
    description: 'Supplier Name of last Board Purchase created for this Job',
  })
  @Expose()
  supplierName!: string;

  // Voided
  //
  @ApiProperty({
    title: 'Voided',
  })
  @Expose()
  voided!: boolean;
  //
  // Model fields
  //

  @ApiProperty({
    title: 'Model Id',
  })
  @Expose()
  modelId!: string;

  @ApiProperty({
    title: 'Supervisor Full Name',
  })
  @Expose()
  supervisorFullNames!: string;

  @ApiProperty({
    title: 'Model Name',
  })
  @Expose()
  modelName!: string;

  @ApiProperty({
    title: 'PO Signed Date',
  })
  @Expose()
  poSignedAt?: Date;

  @ApiProperty({
    title: 'PO Status',
  })
  @Expose()
  poStatus!: string;

  @ApiProperty({
    title: 'PO Order Number',
  })
  @Expose()
  orderNumber!: string;

  @ApiProperty({
    title: 'Pre-Rock',
    description: 'Indicates if the job includes a pre-rock option.',
    type: 'boolean',
  })
  @Expose()
  preRock!: boolean;

  @ApiPropertyOptional({
    type: () => GeographyPointDto,
    nullable: true,
    title: 'Job Geo',
    description: 'GPS location of the job.',
  })
  @IsOptional()
  @ValidateNested()
  @Type(() => GeographyPointDto)
  @Expose()
  geo!: Point | null;
}
